import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface AddKnowledgeToCandidateResponse extends BackendResponse {}
export interface AddKnowledgeToCandidateParameters extends NextApiParams {
  firmId: number;
  knowledgeType: number;
  candidateId: number;
  comment: string;
  level: number;
  expirationDate: string;
  duplicateCheck: boolean;
}

export const addKnowledgeToCandidate = withNextApi<
  AddKnowledgeToCandidateResponse,
  AddKnowledgeToCandidateParameters
>("/cvp/CvpAddKnowledgeToCandidate");
